import { suppliesCollectionIdFormat } from "@redotech/redo-marketplace-id";
import * as z from "zod";

const RedoSuppliesCollectionSchema_ = z.object({
  id: suppliesCollectionIdFormat.schema,
  title: z.string(),
});
export const RedoSuppliesCollectionSchema: z.ZodType<RedoSuppliesCollection> =
  RedoSuppliesCollectionSchema_;
export interface RedoSuppliesCollection extends z.infer<
  typeof RedoSuppliesCollectionSchema_
> {}

export const getRedoSuppliesCollections = {
  name: "getRedoSuppliesCollections" as const,
  input: z.object({}),
  output: z.object({ collections: z.array(RedoSuppliesCollectionSchema) }),
};
